<template>
  <div class="content-box">
    <img src="~img/index_bg.jpg" width="100%" alt="" class="bg_img">
    <div class="content" ref="nav0">
      <div class="head_nav">
        <img :src="getPic('logo','png')" alt="" class="logo">
        <div class="nav-btn-outer">
          <div class="nav" v-for="(item, index) in navs" :class="[`nav_${index}`,{'nav_focus': index === navFocusFlag}]"
               @mouseenter.stop="navFocus(index)" @mouseleave.stop="navFocus(-1)" @click.stop="scrollDom(index)">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="gsjj" ref="nav1"></div>
      <div class="tdjs" ref="nav2"></div>
      <div class="gscp" ref="nav3"></div>
      <div class="wmdys" ref="nav4"></div>
      <div class="wmdmb" ref="nav5"></div>
      <div class="product">
        <img src="~img/wjfz_icon.png" width="100%" alt="" class="product_img"
             @click.stop="openOthers('prod')">
        <img src="~img/wjfz_word.png" width="100%" alt="" class="product_word"
             @click.stop="openOthers('prod')">
      </div>
      <div class="box-bottom">
        <div v-for="(item, index) in bottomLink" :class="`url${index+1}`" @click.stop="openOthers(item)">
          {{ item.name }}
        </div>
        <div class="beian0">
          <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank"></a>
        </div>
        <div class="beian">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51019002007896" rel="noreferrer" target="_blank"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return {
      navs: [
        "首页", "公司简介", "团队介绍", "公司产品", "我们的优势", "我们的目标"
      ],
      navFocusFlag: false,
      bottomLink: [
        {
          "name": "隐私协议",
          "router": "ysxy",
          "link": "https://fanyukaitian.com.cn/yhxy"
        },
        {
          "name": "用户协议",
          "router": "ysxy",
          "link": "https://fanyukaitian.com.cn/yhxy"
        }
      ]
    }
  },
  created() {
  },
  mounted() {
  },
  watch: {},
  methods: {
    //底部跳转链接
    openOthers(item) {
      if (item=== 'prod') {
        window.open('https://fanyukaitian.com.cn/wj/', '_blank');
      } else {
        // window.open(item.link, '_blank');
        this.$router.push({
          name: item.router
        }).catch(() => {});
      }
    },
    openUserTerm() {
      window.open(this.outLink.userTerm, '_blank');
    },
    openPrivacyTerm() {
      window.open(this.outLink.privacyTerm, '_blank');
    },
    getPic(pic, type) {
      return require(`img/${pic}.${type}`);
    },
    navFocus(index) {
      this.navFocusFlag = index;
    },
    scrollDom(ref) {
      this.$refs[`nav${ref}`].scrollIntoView();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "~styles/index.less";

.content-box {
  width: 19.2rem;

  .content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 59.33rem;
    z-index: 1;

    .head_nav {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 0.78rem;
      z-index: 1000;

      .logo {
        float: left;
        margin: 0.2rem 0 0 0.53rem;
        width: 1.5rem;
      }

      .nav-btn-outer {
        display: flex;
        margin-left: 4.53rem;
        width: 12.21rem;
        height: 0.78rem;
        align-items: center;
        justify-content: space-between;

        .nav {
          width: auto;
          height: 100%;
          font-weight: 400;
          font-size: 0.2rem;
          color: rgba(255, 255, 255, 1);
          line-height: 0.78rem;
          text-align: center;
          cursor: pointer;

          &.nav_focus {
            color: rgba(255, 114, 0, 1);
          }
        }
      }
    }

    .gsjj{
      position: absolute;
      top: 10rem;
      width: 100%;
    }
    .tdjs{
      position: absolute;
      top: 18.4rem;
      width: 100%;
    }
    .gscp{
      position: absolute;
      top: 25.6rem;
      width: 100%;
    }
    .wmdys{
      position: absolute;
      top: 37rem;
      width: 100%;
    }
    .wmdmb{
      position: absolute;
      top: 47rem;
      width: 100%;
    }

    .product {
      position: absolute;
      width: 4.8rem;
      left: 2.1rem;
      top: 27.8rem;
      cursor: pointer;

      .product_img{
        width: 100%;
      }

      .product_word{
        width: 2.1rem;
        margin-top: .2rem;
      }
    }

    .box-bottom {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;

      .url1 {
        position: absolute;
        bottom: 1.73rem;
        left: 3.9rem;
        cursor: pointer;
        font-family: FZYaSongS-B-GB;
        font-weight: 400;
        font-size: 0.2rem;
        color: rgba(221, 140, 75, 1);
      }

      .url2 {
        position: absolute;
        bottom: 1.73rem;
        left: 5.16rem;
        cursor: pointer;
        font-family: FZYaSongS-B-GB;
        font-weight: 400;
        font-size: 0.2rem;
        color: rgba(221, 140, 75, 1);
      }
      .beian0{
        position: absolute;
        bottom: .66rem;
        left: 3.9rem;
        width: 4rem;
        height: .2rem;
        line-height: .2rem;
        cursor: pointer;
        a{
          display: inline-block;
          margin-left: .1rem;
          width: 100%;
          height: 100%;
        }
      }
      .beian{
        position: absolute;
        bottom: .28rem;
        left: 3.9rem;
        width: 3.5rem;
        height: .2rem;
        line-height: .2rem;
        cursor: pointer;
        a{
          display: inline-block;
          margin-left: .1rem;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/home.vue